var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u(
      [
        {
          key: "datetime",
          fn: function() {
            return [
              _c("QpeDatetime", {
                attrs: {
                  props_date: _vm.date,
                  props_time: _vm.time,
                  name: _vm.default_value
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                }
              })
            ]
          },
          proxy: true
        },
        _vm.enable_route_filter
          ? {
              key: "filter_condition_options",
              fn: function() {
                return [
                  _c("MonitorOptionSet", {
                    attrs: { option_set: _vm.option_set },
                    on: { filter_data: _vm.filter_data }
                  })
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "data_table",
          fn: function(slot_props) {
            return [
              _c("QpeDatatable", {
                attrs: {
                  data: _vm.table_data,
                  headers: _vm.header,
                  name: _vm.default_value,
                  error_text: _vm.error_text,
                  search: slot_props.search,
                  should_draw_diagram_header: _vm.should_draw_diagram_header,
                  should_display_info_header_key_value:
                    _vm.should_display_info_header_key_value,
                  generate_tooltop_display_info:
                    _vm.generate_tooltop_display_info,
                  enable_diagram_slot: true,
                  show_footer: false,
                  show_download_pdf_btn: true,
                  is_show_chart_dialog_parent: _vm.is_show_chart_dialog
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time,
                  "open-chart": _vm.assign_chart_component,
                  "update:is_show_chart_dialog_parent": function($event) {
                    _vm.is_show_chart_dialog = $event
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "diagram_dialog",
                      fn: function(ref) {
                        var close_dialog = ref.close_dialog
                        return [
                          _vm.is_show_chart_dialog
                            ? [
                                _vm.should_draw_stations_diagram_header.includes(
                                  _vm.current_table_header
                                )
                                  ? [
                                      _c("MonitorStations", {
                                        attrs: {
                                          station_data:
                                            _vm.immutable_table_data,
                                          zone_span: _vm.current_table_header,
                                          zone_table_value:
                                            _vm.current_choosed_table_value,
                                          date: _vm.date,
                                          time: _vm.time
                                        },
                                        on: {
                                          "close-chart-dialog": close_dialog
                                        }
                                      })
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.should_draw_timeseries_diagram_header.includes(
                                  _vm.current_table_header
                                )
                                  ? [
                                      _c("GisChart", {
                                        attrs: {
                                          id: "belongs_monitor_chart",
                                          chart_options: _vm.chart_options,
                                          default_variable: _vm.$t(
                                            "__rainfall.rainfall"
                                          ),
                                          prop_rain_selected:
                                            _vm.current_table_header,
                                          rain_period_options:
                                            _vm.rain_period_options
                                        },
                                        on: {
                                          "close-chart-dialog": close_dialog
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "table_description",
                      fn: function() {
                        return [
                          _c("span", [
                            _vm._v(
                              '\n                    說明："--"標示，顯示該欄位無資料。 \n                '
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }